import { MetaResponse, RelationGroup } from '@qtek/core/api-core';
import { LanguageOption } from '@qtek/shared/models';
import { MetaCoreState, Role } from '../models';

interface BaseCollection {
  id: string;
  name: string;
}

const extractKeys = <T extends BaseCollection>(
  payload: Record<string, string>
): T[] => {
  return Object.keys(payload).map(
    id =>
      ({
        id,
        name: payload[id],
      }) as T
  );
};

export function applyMeta(meta: Partial<MetaResponse>): Partial<MetaCoreState> {
  return {
    ...(meta.ptlRoleGroups && {
      roles: {
        user: extractKeys<Role>(
          meta.ptlRoleGroups[RelationGroup.USER]['roles']
        ),
        vendor: extractKeys<Role>(
          meta.ptlRoleGroups[RelationGroup.VENDOR]['roles']
        ),
        customer: extractKeys<Role>(
          meta.ptlRoleGroups[RelationGroup.CUSTOMER]['roles']
        ),
        staff: extractKeys<Role>(
          meta.ptlRoleGroups[RelationGroup.STAFF]['roles']
        ),
      },
    }),
    ...(meta.colors && { colors: meta.colors }),
    ...(meta.lngs && { languages: extractKeys<LanguageOption>(meta.lngs) }),
    ...(meta.ptl && {
      title1: meta.ptl.title1,
      title2: meta.ptl.title2,
      guiDomain: meta.ptl.guiDomain,
      guiOnlineBookDomain: meta.ptl.guiOnlineBookDomain,
      guiShrDomain: meta.ptl.guiShrDomain,
      docGuiDomain: meta.ptl.docGuiDomain,
      authGuiDomain: meta.ptl.authGuiDomain,
    }),
    ...(meta.phns && meta.phns.cntrs && { countryCode: meta.phns.cntrs }),
    ...(meta.wsPingPong && { wsPingPong: meta.wsPingPong }),
    ...(meta.token && { token: meta.token }),
  };
}
